import React from 'react';
import { CheckBoxParam, Form, Row, SonForm, SubmitButton, Switch, useForm } from '../../../_lib/Form2';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { ComponentProps } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type EventParticipationEditViewProps = {
  toggleForm: SonForm<CheckBoxParam<'active'>>;
};

function EventParticipationEdit({ toggleForm }: EventParticipationEditViewProps) {
  const { t } = useSonTranslation('EventParticipation');
  const { onSuccess } = useViewContext();
  const { formProps, params, fetchState } = useForm({ form: toggleForm, onSuccess });

  const activeParams = params.getByName('active');

  return (
    <Form {...formProps}>
      <Row>
        <Switch label={t('editView.switchLabel')} param={activeParams} />
      </Row>
      <SubmitButton
        buttonLabel={t('editView.submitButton')}
        messageSuccess={t('editView.status.success')}
        messageSending={t('editView.status.sending')}
        messageFail={t('editView.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const EventParticipationEditView = asFetchableView(EventParticipationEdit);
export type EventParticipationEditView = ComponentProps<typeof EventParticipationEditView>;
